'use client';

import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@alltrails/denali/components/IconButton';
import Close from '@alltrails/denali/icons/Close';
import ExploreNavigationBase from '@/components/ExploreNavigationBase/ExploreNavigationBase';
import { useReturnToExploreRoot } from '@/hooks/useReturnToExploreRoot';
import { useAppSelector } from '@/utils/redux';
import styles from './ExplorePOINavigation.module.scss';

const ExplorePOINavigation = () => {
  const intl = useIntl();
  const [searchHasFocus, setSearchHasFocus] = useState(false);
  const { poi } = useAppSelector(state => ({
    poi: state.explorePOI.poi
  }));
  const onClearPOISelection = useReturnToExploreRoot(true /* persistMapLocation */);

  const ClearPOIButton = useMemo(() => {
    if (searchHasFocus) {
      return null;
    }

    return (
      <IconButton
        className={styles.clearFocus}
        icon={{ Component: Close }}
        onClick={onClearPOISelection}
        size="sm"
        testId="clear-focused-poi"
        title={intl.formatMessage({ defaultMessage: 'Clear' })}
        variant="flat"
      />
    );
  }, [intl, onClearPOISelection, searchHasFocus]);

  return (
    <ExploreNavigationBase
      searchPreventNavigationOnSelect
      onInputBlur={() => setSearchHasFocus(false)}
      onInputFocus={() => setSearchHasFocus(true)}
      searchValue={poi?.name}
      tertiarySearchElement={ClearPOIButton}
    />
  );
};

export default ExplorePOINavigation;
